module.exports = "<img src=\"../1_wmn0tUNh1aQVpkkc3z5-mA.gif\" alt=\"\">"


//////////////////
// WEBPACK FOOTER
// ./src/app/portal-cmcti/portal/portal.component.html
// module id = ./src/app/portal-cmcti/portal/portal.component.html
// module chunks = main